import React from 'react';
import cn from 'classnames';
import styles from '@features/voucher-new/styles/voucher-new.module.css';
import { useTranslation } from 'react-i18next';
import { ImageList } from '@shared/config/constants/Images';

const footerLinks = [
  { href: 'https://vuz.com/TermsConditionsPrivacyPolicy.html', textKey: 'terms_and_conditions' },
  { href: 'https://vuz.com/360VUZPlatformPolicy.html', textKey: 'platform_policy' },
  { href: 'https://vuz.com/360VUZCommunityGuidelines.html', textKey: 'community_guidelines' },
];

export const VoucherFooter = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.footerWrapper}>
      <div className={styles.footerContainer}>
        <div className={styles.linkContainer}>
          {footerLinks.map(({ href, textKey }) => {
            return (
              <a key={textKey} href={href}>
                <span className={cn(styles.link, 'thankyou_govip_footerlink')}>{t(textKey)}</span>
              </a>
            );
          })}
        </div>
        <div className={styles.copyRightWrapper}>
          {['vuz_copyright_1', 'vuz_copyright_2'].map((key) => {
            return (
              <span key={key} className={cn(styles.copyRight, 'thankyou_govip_footercopyright')}>
                {t(key)}
              </span>
            );
          })}
        </div>
        <img width={'60px'} height={'20px'} src={ImageList.vuz_vip_logo_image} alt="VipLogo" />
      </div>
    </div>
  );
};
